var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	41981: {
		fallback: () => (__webpack_require__.e(3411).then(() => (() => (__webpack_require__(96540))))),
		shareScope: ["modern18"],
		singleton: true,
		requiredVersion: "^18.3.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	60594: {
		fallback: () => (__webpack_require__.e(739).then(() => (() => (__webpack_require__(77593))))),
		shareScope: ["modern18"],
		singleton: true,
		requiredVersion: "^5.101.4",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@tanstack/react-query",

	},
	79203: {
		fallback: () => (Promise.all([__webpack_require__.e(3411), __webpack_require__.e(638)]).then(() => (() => (__webpack_require__(40961))))),
		shareScope: ["modern18"],
		singleton: true,
		requiredVersion: "^18.3.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"1981": [
		41981
	],
	"5828": [
		60594,
		79203
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}